import React, { useState } from 'react';
import { Form, Input, Radio, Rate } from 'antd';

type IProps = { form: any };

const QuotesQuestions: React.FC<IProps> = ({ form }) => {
    const [fourth_answer, set_fourth_answer] = useState(0);
    return (
        <>
            <Form.Item
                name="second_answer"
                label={'Were you able to upload all of your files?'}
                rules={[{ required: true, message: 'Please answer this question' }]}
            >
                <Radio.Group>
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                name="third_answer"
                label={'Were you able to add in all of your notes and requirements?'}
                rules={[{ required: true, message: 'Please answer this question' }]}
            >
                <Radio.Group>
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                name="fourth_answer"
                label="How would you rate your experience with the portal overall?"
                rules={[{ required: true, message: 'Please rate us' }]}
            >
                <Rate value={fourth_answer} onChange={value => set_fourth_answer(value)} />
            </Form.Item>
            {form.isFieldTouched('fourth_answer') && fourth_answer <= 2 ? (
                <Form.Item
                    name="first_optional_answer"
                    label={'What would you like us to improve?'}
                    rules={[{ required: false, message: 'Please rate us' }]}
                >
                    <Input />
                </Form.Item>
            ) : null}

            <Form.Item
                name="sixth_answer"
                label="How likely are you to recommend the portal to your friends/family/colleagues?"
                rules={[{ required: true, message: 'Please rate us' }]}
            >
                <Rate />
            </Form.Item>
        </>
    );
};

export default QuotesQuestions;
